module.exports = __webpack_public_path__ + "img/BluespeedAsset_2.482fa596.jpeg";